import { isApiSuccess } from '@/utils/api/functions';
import axios from '@/utils/axios';
import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';

export default async function lineBinding({
  to,
  from,
  next,
  router
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router: Router;
}) {
  console.log('=============lineBinding====================');
  const { line_binding_uid } = from.query;

  if (!Array.isArray(line_binding_uid) && line_binding_uid) {
    const res = await axios.post('/LineBinding/BindingLineWithFundayMember', {
      lineUserId: line_binding_uid
    });

    if (isApiSuccess(res)) {
      console.log('=============close====================');
      // window.close();
      window.location.href = 'https://line.me/R/ti/p/@ota3745y';
    }
  }

  return next();
}
